import _ from "lodash";
import { FtlRouteViewModel } from "../../../../../ViewModel/FtlRouteViewModel";

export function getCrossingCountriesFromRoutingGrid(
  ftlRoute: FtlRouteViewModel
) {
  const routingTable = ftlRoute.RoutingTable || [];
  const allCountries = routingTable.map((x) => x.Country);
  return _.uniq(allCountries);
}
